import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { SalutationSubForm, Schema as SalutationSchema } from '../subforms/Salutation';
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';
import { EntranceDateSubForm } from '../subforms/EntranceDate';
import { OtherInformationInformalSubForm, Schema as OtherInformationSchema } from '../subforms/OtherInformationInformal';
import { AdditionalConsentSubForm } from '../subforms/AdditionalConsent';
import { DocumentsDiplomaSubForm, Schema as DocumentsDiplomaSchema } from '../subforms/DocumentsDiploma';
import { PrivacyConsentSubForm } from '../subforms/PrivacyConsentInformal';

export const MBNAzubibewerbungSchema = (settings) => (
    Yup.object()
        .concat(SalutationSchema)
        .concat(NameAndContactSchema(settings))
        .concat(OtherInformationSchema)
        .concat(DocumentsDiplomaSchema(settings))
);

export const MBNAzubibewerbung = (props) => {
    const { colors, settings, dataSecurityUrl } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={SalutationSubForm} colors={colors} />
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <Field component={EntranceDateSubForm} colors={colors} settings={settings} />
            <Field component={OtherInformationInformalSubForm} colors={colors} settings={settings} />
            <Field component={AdditionalConsentSubForm} />
            <Field component={DocumentsDiplomaSubForm} colors={colors} settings={settings} />
            <Field component={PrivacyConsentSubForm} dataSecurityUrl={dataSecurityUrl} />
        </>
    );
}